import React from "react";

import './FormSide.css';
import Copyright from "../../molecules/copyright-footer/Copyright";

const FormSide = ()=>{
    
    return(
        <div className="formSide">
            <Copyright/>
        </div>
    )
}

export default FormSide;